import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  data: {
    color: "black",
    marginRight: "18px",
  },
  formControl: {
    right: 0,
    top: 0,
    margin: "10px",
  },
});
